import React from "react";
import "../App.css";
import { Container } from "@mui/system";
import { Typography, Divider } from "@mui/material";/* 
import Lombriz from "../assets/gallery/Lombriz.gif";
import Marvin2 from "../assets/gallery/Marvin2.png";
import Murcielago from "../assets/gallery/Murcielago.png";
import topo from "../assets/gallery/topo.gif"; */
import Scene1 from "../assets/gallery/scene1.png";
import Scene2 from "../assets/gallery/scene2.png";
import Scene3 from "../assets/gallery/scene3.png";
import Scene4 from "../assets/gallery/scene4.png";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper";
const MEDIA = [
  /*   { img: Lombriz, title: "Lombriz" },
    { img: Marvin2, title: "Marvin Personaje principal" },
    { img: Murcielago, title: "Mucielago" }, 
    { img: topo, title: "Topo" },*/
  { img: Scene1, title: "Nivel" },
  { img: Scene2, title: "Nivel" },
  { img: Scene3, title: "Nivel" },
  { img: Scene4, title: "Nivel" },
];
export default function Galeria() {
  const GenerateCards = () => {
    const galleryItems = MEDIA.map((item, index) => {
      return (
        <SwiperSlide key={index} className="swiper-slide">
          <Container>
            <Typography variant="h5">{item.title}</Typography>
          </Container>
          <img src={item.img} alt={item.title} />
        </SwiperSlide>
      );
    });
    return (
      <>
        <Container
          sx={{
            display: { xs: "none", md: "flex" },
            flexWrap: "wrap",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Swiper
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            /*  slidesPerView={2}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }} */
            keyboard={{
              enabled: true,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[EffectCoverflow, Pagination]}
            className="mySwiper"
          >
            {galleryItems}
          </Swiper>
        </Container>
        <Container
          sx={{
            display: { xs: "flex", md: "none" },
            flexWrap: "wrap",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Swiper
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            /*  slidesPerView={2}
             coverflowEffect={{
               rotate: 50,
               stretch: 0,
               depth: 100,
               modifier: 1,
               slideShadows: true,
             }} */
            keyboard={{
              enabled: true,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[EffectCoverflow, Pagination]}
            className="mySwiper"
          >
            {galleryItems}
          </Swiper>
        </Container>
      </>
    );
  };
  return (
    <Container
      sx={{ display: "block", width: "80%", textAlign: "center" }}
      id="galería"
    >
      <Typography variant="h2">Galería</Typography>

      <GenerateCards />
      <Divider />
    </Container>
  );
}
